// extracted by mini-css-extract-plugin
export default {"services":"Services_services__32BTz","box":"Services_box__vTyWA","servicesText":"Services_servicesText__SkCdG"};